import { createSelector } from 'reselect';
import { MAX_ATTEMPTS } from 'src/constants/constants';

// selector
const getLogin = state => state.login;
// const getUserInfo = state => state.login.userInfo;
// reselect function
export const getLoginState = createSelector(
  [getLogin],
  login => login,
);

export const getUserInfoSelector = createSelector(
  [getLoginState],
  login => login.userInfo,
);
export const isEYProSelector = createSelector(
  [getLoginState],
  login => login.userRoles.eyPro,
);
export const isEYAdminSelector = createSelector(
  [getLoginState],
  login => login.userRoles.eyAdmin,
);
export const isApplicantSelector = createSelector(
  [getLoginState],
  login => login.userRoles.applicant,
);
export const isCorpClientSelector = createSelector(
  [getLoginState],
  login => login.userRoles.corpClient,
);
export const isCorporateClientLineManagerSelector = createSelector(
  [getLoginState],
  login => login.userRoles.corporateClientlineManager,
);
export const isDeleteProfileSelector = createSelector(
  [getLoginState],
  login => login.userRoles.deleteProfile,
);
export const getUserRolesSelector = createSelector(
  [getLoginState],
  login => login.userRoles,
);

export const getUserIsLocked = createSelector(
  [getLoginState],
  data => {
    return data.numberAttempts >= MAX_ATTEMPTS;
  },
);



// WEBPACK FOOTER //
// ./src/ui/features/Login/state/loginReselect.js